// js/sections/FeaturedCollectionSection.js


class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    

    this.settings = JSON.parse(this.getAttribute("data-settings")) || {};
    this._attachListeners();
  }
  disconnectedCallback() {
    // Slider cleanup is handled by cos-slider component
  }
  connectedCallback() {
    // Re-initialize if needed when element is connected
  }
  _attachListeners() {
    // Quick view functionality is handled by cos-product-item component
    // ResizeObserver is handled by cos-slider component
  }
  /**
   * On Safari 11.1 and lower, the browser incorrectly calculate the height of flex and grid items due to a bug
   * on how padding percentage is calculated (that we use for allocating image space). This is solved in Safari 11.1 and higher.
   *
   * For those browsers, we fix that in JavaScript by setting the height directly for each aspect ratio image
   *
   * @private
   */



}
if (!window.customElements.get("cos-featured-collection")) window.customElements.define("cos-featured-collection", FeaturedCollectionSection);
